import type { KametiGroup } from "../services/types";

/**
 * Kameti groups (Phase 2). Tickets for the legacy groups g1–g8 mirror the member
 * enrollments authored in Phase 1 so membership, outstanding balances and won
 * cycles agree across both modules. New groups (g9–g13) exercise Draft, Completed
 * and Cancelled states. All cycle figures here are illustrative demo data — real
 * figures come from the backend once a group is active.
 */
export const MOCK_KAMETI_GROUPS: KametiGroup[] = [
  {
    id: "g1",
    groupCode: "2024-0001",
    name: "Lakshmi-10",
    monthlyInstallment: 10000,
    memberCount: 14,
    chitValue: 140000,
    startDate: "2024-01-05T00:00:00.000Z",
    auctionDay: 10,
    dueDay: 12,
    organizerMemberId: "m4",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 500,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 100,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "active",
    tickets: [
      { ticketNumber: "TN-1101", memberId: "m1" },
      { ticketNumber: "TN-1105", memberId: "m4" },
      { ticketNumber: "TN-1109", memberId: "m8" },
      { ticketNumber: "TN-1112", memberId: "m12" },
      { ticketNumber: "TN-1115", memberId: "m15" },
      { ticketNumber: "TN-1118", memberId: "m18" },
      { ticketNumber: "TN-1122", memberId: "m23" },
      { ticketNumber: "TN-1125", memberId: "m27" },
      { ticketNumber: "TN-1130", memberId: "m33" },
      { ticketNumber: "TN-1135", memberId: "m39" },
      { ticketNumber: "TN-1140", memberId: "m44" },
      { ticketNumber: "TN-1145", memberId: "m49" },
      { ticketNumber: "TN-1150", memberId: "m55" },
      { ticketNumber: "TN-1155", memberId: "m60" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m12", winningBid: 134000 },
      { cycle: 2, memberId: "m4", winningBid: 140000 },
      { cycle: 3, memberId: "m1", winningBid: 132000 },
      { cycle: 4, memberId: "m18", winningBid: 136000 },
      { cycle: 5, memberId: "m8", winningBid: 133000 },
      { cycle: 6, memberId: "m15", winningBid: 135000 },
    ],
    createdBy: "Anita Desai",
    createdAt: "2024-01-05T09:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2025-06-01T10:00:00.000Z",
  },
  {
    id: "g2",
    groupCode: "2025-0002",
    name: "Lakshmi-5",
    monthlyInstallment: 5000,
    memberCount: 18,
    chitValue: 90000,
    startDate: "2025-01-05T00:00:00.000Z",
    auctionDay: 5,
    dueDay: 7,
    organizerMemberId: "m4",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 250,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 50,
    lateFeeIsPercent: false,
    lateFeePerDay: true,
    status: "active",
    tickets: [
      { ticketNumber: "TN-2201", memberId: "m10" },
      { ticketNumber: "TN-2204", memberId: "m1" },
      { ticketNumber: "TN-2209", memberId: "m4" },
      { ticketNumber: "TN-2214", memberId: "m7" },
      { ticketNumber: "TN-2218", memberId: "m13" },
      { ticketNumber: "TN-2220", memberId: "m16" },
      { ticketNumber: "TN-2224", memberId: "m21" },
      { ticketNumber: "TN-2228", memberId: "m25" },
      { ticketNumber: "TN-2230", memberId: "m30" },
      { ticketNumber: "TN-2231", memberId: "m31" },
      { ticketNumber: "TN-2234", memberId: "m34" },
      { ticketNumber: "TN-2235", memberId: "m35" },
      { ticketNumber: "TN-2240", memberId: "m40" },
      { ticketNumber: "TN-2245", memberId: "m45" },
      { ticketNumber: "TN-2248", memberId: "m48" },
      { ticketNumber: "TN-2250", memberId: "m53" },
      { ticketNumber: "TN-2255", memberId: "m55" },
      { ticketNumber: "TN-2258", memberId: "m58" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m10", winningBid: 87000 },
      { cycle: 2, memberId: "m4", winningBid: 90000 },
      { cycle: 3, memberId: "m1", winningBid: 87500 },
      { cycle: 4, memberId: "m16", winningBid: 86000 },
    ],
    createdBy: "Anita Desai",
    createdAt: "2025-01-05T09:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2025-06-02T11:00:00.000Z",
  },
  {
    id: "g3",
    groupCode: "2023-0003",
    name: "Durga-20",
    monthlyInstallment: 20000,
    memberCount: 10,
    chitValue: 200000,
    startDate: "2023-11-20T00:00:00.000Z",
    auctionDay: 20,
    dueDay: 25,
    organizerMemberId: "m43",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: 1,
    maxDiscountPct: 10,
    bidStep: 1000,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 7,
    lateFee: 1,
    lateFeeIsPercent: true,
    lateFeePerDay: true,
    status: "active",
    tickets: [
      { ticketNumber: "TN-3302", memberId: "m2" },
      { ticketNumber: "TN-3311", memberId: "m9" },
      { ticketNumber: "TN-3306", memberId: "m13" },
      { ticketNumber: "TN-3316", memberId: "m17" },
      { ticketNumber: "TN-3320", memberId: "m22" },
      { ticketNumber: "TN-3324", memberId: "m32" },
      { ticketNumber: "TN-3335", memberId: "m39" },
      { ticketNumber: "TN-3340", memberId: "m43" },
      { ticketNumber: "TN-3350", memberId: "m51" },
      { ticketNumber: "TN-3355", memberId: "m59" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m2", winningBid: 192000 },
      { cycle: 2, memberId: "m43", winningBid: 200000 },
      { cycle: 3, memberId: "m9", winningBid: 190000 },
      { cycle: 4, memberId: "m17", winningBid: 194000 },
      { cycle: 5, memberId: "m32", winningBid: 188000 },
      { cycle: 6, memberId: "m13", winningBid: 191000 },
      { cycle: 7, memberId: "m22", winningBid: 189000 },
      { cycle: 8, memberId: "m39", winningBid: 193000 },
    ],
    createdBy: "Suresh Kumar",
    createdAt: "2023-11-20T10:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2025-06-03T09:00:00.000Z",
  },
  {
    id: "g4",
    groupCode: "2024-0004",
    name: "Saraswati-2",
    monthlyInstallment: 2000,
    memberCount: 13,
    chitValue: 26000,
    startDate: "2024-11-01T00:00:00.000Z",
    auctionDay: 1,
    dueDay: 3,
    organizerMemberId: "m13",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 100,
    blockOverdueBidding: false,
    dividendTiming: "next_month",
    gracePeriodDays: 3,
    lateFee: 25,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "active",
    tickets: [
      { ticketNumber: "TN-4403", memberId: "m11" },
      { ticketNumber: "TN-4408", memberId: "m12" },
      { ticketNumber: "TN-4412", memberId: "m3" },
      { ticketNumber: "TN-4415", memberId: "m15" },
      { ticketNumber: "TN-4420", memberId: "m7" },
      { ticketNumber: "TN-4422", memberId: "m22" },
      { ticketNumber: "TN-4426", memberId: "m26" },
      { ticketNumber: "TN-4430", memberId: "m32" },
      { ticketNumber: "TN-4435", memberId: "m37" },
      { ticketNumber: "TN-4440", memberId: "m42" },
      { ticketNumber: "TN-4445", memberId: "m47" },
      { ticketNumber: "TN-4450", memberId: "m55" },
      { ticketNumber: "TN-4455", memberId: "m59" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m26", winningBid: 24800 },
      { cycle: 2, memberId: "m13", winningBid: 26000 },
    ],
    createdBy: "Priya Sharma",
    createdAt: "2024-11-01T09:00:00.000Z",
    updatedBy: "Priya Sharma",
    updatedAt: "2025-06-04T10:00:00.000Z",
  },
  {
    id: "g5",
    groupCode: "2022-0005",
    name: "Ganesh-50",
    monthlyInstallment: 50000,
    memberCount: 9,
    chitValue: 450000,
    startDate: "2022-01-10T00:00:00.000Z",
    auctionDay: 15,
    dueDay: 18,
    organizerMemberId: "m43",
    reservedCycle: 1,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: 8,
    bidStep: 2500,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 0,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "active",
    tickets: [
      { ticketNumber: "TN-5540", memberId: "m43" },
      { ticketNumber: "TN-5501", memberId: "m3" },
      { ticketNumber: "TN-5506", memberId: "m12" },
      { ticketNumber: "TN-5510", memberId: "m19" },
      { ticketNumber: "TN-5515", memberId: "m23" },
      { ticketNumber: "TN-5530", memberId: "m32" },
      { ticketNumber: "TN-5535", memberId: "m39" },
      { ticketNumber: "TN-5545", memberId: "m50" },
      { ticketNumber: "TN-5550", memberId: "m56" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m43", winningBid: 450000 },
      { cycle: 2, memberId: "m12", winningBid: 440000 },
      { cycle: 3, memberId: "m19", winningBid: 435000 },
      { cycle: 4, memberId: "m23", winningBid: 438000 },
      { cycle: 5, memberId: "m32", winningBid: 442000 },
      { cycle: 6, memberId: "m39", winningBid: 436000 },
      { cycle: 7, memberId: "m50", winningBid: 439000 },
      { cycle: 8, memberId: "m3", winningBid: 432000 },
    ],
    createdBy: "Anita Desai",
    createdAt: "2022-01-10T09:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2025-06-05T11:00:00.000Z",
  },
  {
    id: "g6",
    groupCode: "2023-0006",
    name: "Annapurna-1",
    monthlyInstallment: 1000,
    memberCount: 13,
    chitValue: 13000,
    startDate: "2023-04-12T00:00:00.000Z",
    auctionDay: 12,
    dueDay: 15,
    organizerMemberId: "m8",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 50,
    blockOverdueBidding: false,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 0,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "active",
    tickets: [
      { ticketNumber: "TN-6608", memberId: "m8" },
      { ticketNumber: "TN-6605", memberId: "m14" },
      { ticketNumber: "TN-6612", memberId: "m11" },
      { ticketNumber: "TN-6602", memberId: "m6" },
      { ticketNumber: "TN-6618", memberId: "m15" },
      { ticketNumber: "TN-6622", memberId: "m21" },
      { ticketNumber: "TN-6625", memberId: "m27" },
      { ticketNumber: "TN-6630", memberId: "m30" },
      { ticketNumber: "TN-6635", memberId: "m37" },
      { ticketNumber: "TN-6640", memberId: "m45" },
      { ticketNumber: "TN-6645", memberId: "m48" },
      { ticketNumber: "TN-6650", memberId: "m54" },
      { ticketNumber: "TN-6655", memberId: "m57" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m11", winningBid: 12600 },
      { cycle: 2, memberId: "m8", winningBid: 13000 },
      { cycle: 3, memberId: "m15", winningBid: 12700 },
      { cycle: 4, memberId: "m21", winningBid: 12550 },
      { cycle: 5, memberId: "m6", winningBid: 12500 },
      { cycle: 6, memberId: "m27", winningBid: 12450 },
      { cycle: 7, memberId: "m30", winningBid: 12650 },
      { cycle: 8, memberId: "m37", winningBid: 12500 },
      { cycle: 9, memberId: "m14", winningBid: 12400 },
      { cycle: 10, memberId: "m45", winningBid: 12300 },
    ],
    createdBy: "Suresh Kumar",
    createdAt: "2023-04-12T09:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2025-06-06T09:30:00.000Z",
  },
  {
    id: "g7",
    groupCode: "2024-0007",
    name: "Mahalaxmi-25",
    monthlyInstallment: 25000,
    memberCount: 12,
    chitValue: 300000,
    startDate: "2024-05-10T00:00:00.000Z",
    auctionDay: 10,
    dueDay: 12,
    organizerMemberId: "m43",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 1000,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 1,
    lateFeeIsPercent: true,
    lateFeePerDay: true,
    status: "active",
    tickets: [
      { ticketNumber: "TN-7703", memberId: "m4" },
      { ticketNumber: "TN-7710", memberId: "m9" },
      { ticketNumber: "TN-7712", memberId: "m16" },
      { ticketNumber: "TN-7716", memberId: "m20" },
      { ticketNumber: "TN-7720", memberId: "m23" },
      { ticketNumber: "TN-7724", memberId: "m29" },
      { ticketNumber: "TN-7730", memberId: "m36" },
      { ticketNumber: "TN-7735", memberId: "m41" },
      { ticketNumber: "TN-7740", memberId: "m43" },
      { ticketNumber: "TN-7745", memberId: "m47" },
      { ticketNumber: "TN-7750", memberId: "m51" },
      { ticketNumber: "TN-7755", memberId: "m57" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m4", winningBid: 289000 },
      { cycle: 2, memberId: "m43", winningBid: 300000 },
      { cycle: 3, memberId: "m9", winningBid: 292000 },
    ],
    createdBy: "Anita Desai",
    createdAt: "2024-05-10T10:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2025-06-07T10:00:00.000Z",
  },
  {
    id: "g8",
    groupCode: "2024-0008",
    name: "Kuber-15",
    monthlyInstallment: 15000,
    memberCount: 9,
    chitValue: 135000,
    startDate: "2024-03-15T00:00:00.000Z",
    auctionDay: 15,
    dueDay: 18,
    organizerMemberId: "m9",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: 12,
    bidStep: 500,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 200,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "active",
    tickets: [
      { ticketNumber: "TN-8810", memberId: "m3" },
      { ticketNumber: "TN-8815", memberId: "m9" },
      { ticketNumber: "TN-8820", memberId: "m19" },
      { ticketNumber: "TN-8824", memberId: "m28" },
      { ticketNumber: "TN-8830", memberId: "m34" },
      { ticketNumber: "TN-8840", memberId: "m41" },
      { ticketNumber: "TN-8845", memberId: "m46" },
      { ticketNumber: "TN-8850", memberId: "m52" },
      { ticketNumber: "TN-8855", memberId: "m58" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m3", winningBid: 131000 },
      { cycle: 2, memberId: "m9", winningBid: 135000 },
      { cycle: 3, memberId: "m34", winningBid: 130000 },
    ],
    createdBy: "Priya Sharma",
    createdAt: "2024-03-15T09:00:00.000Z",
    updatedBy: "Priya Sharma",
    updatedAt: "2025-06-08T09:00:00.000Z",
  },
  {
    id: "g9",
    groupCode: "2026-0009",
    name: "Kuber-20",
    monthlyInstallment: 20000,
    memberCount: 20,
    chitValue: 400000,
    startDate: "2026-09-10T00:00:00.000Z",
    auctionDay: 10,
    dueDay: 12,
    organizerMemberId: "m4",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 1000,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 100,
    lateFeeIsPercent: false,
    lateFeePerDay: true,
    status: "draft",
    tickets: [
      { ticketNumber: "T-01", memberId: "m1" },
      { ticketNumber: "T-02", memberId: "m4" },
      { ticketNumber: "T-03", memberId: "m8" },
      { ticketNumber: "T-04", memberId: "m12" },
      { ticketNumber: "T-05", memberId: "m15" },
      { ticketNumber: "T-06", memberId: "m18" },
      { ticketNumber: "T-07", memberId: "m23" },
      { ticketNumber: "T-08", memberId: "m27" },
    ],
    wonCycles: [],
    createdBy: "Anita Desai",
    createdAt: "2026-07-15T09:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2026-07-18T10:00:00.000Z",
  },
  {
    id: "g10",
    groupCode: "2026-0010",
    name: "Lakshmi-20",
    monthlyInstallment: 5000,
    memberCount: 20,
    chitValue: 100000,
    startDate: "2026-10-05T00:00:00.000Z",
    auctionDay: 5,
    dueDay: 7,
    organizerMemberId: "m43",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: 1,
    maxDiscountPct: 8,
    bidStep: 250,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 50,
    lateFeeIsPercent: false,
    lateFeePerDay: true,
    status: "draft",
    tickets: [
      { ticketNumber: "T-01", memberId: "m43" },
      { ticketNumber: "T-02", memberId: "m16" },
      { ticketNumber: "T-03", memberId: "m21" },
      { ticketNumber: "T-04", memberId: "m25" },
      { ticketNumber: "T-05", memberId: "m30" },
    ],
    wonCycles: [],
    createdBy: "Suresh Kumar",
    createdAt: "2026-07-20T09:00:00.000Z",
    updatedBy: "Suresh Kumar",
    updatedAt: "2026-07-22T10:00:00.000Z",
  },
  {
    id: "g11",
    groupCode: "2026-0011",
    name: "Mahalaxmi-15",
    monthlyInstallment: 15000,
    memberCount: 15,
    chitValue: 225000,
    startDate: "2026-11-08T00:00:00.000Z",
    auctionDay: 8,
    dueDay: 10,
    organizerMemberId: "m29",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: 10,
    bidStep: 500,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 150,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "draft",
    tickets: [],
    wonCycles: [],
    createdBy: "Anita Desai",
    createdAt: "2026-08-01T09:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2026-08-01T09:00:00.000Z",
  },
  {
    id: "g12",
    groupCode: "2025-0012",
    name: "Annapurna-2",
    monthlyInstallment: 2000,
    memberCount: 10,
    chitValue: 20000,
    startDate: "2025-01-10T00:00:00.000Z",
    auctionDay: 10,
    dueDay: 12,
    organizerMemberId: "m14",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 100,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 25,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "completed",
    tickets: [
      { ticketNumber: "T-01", memberId: "m5" },
      { ticketNumber: "T-02", memberId: "m14" },
      { ticketNumber: "T-03", memberId: "m24" },
      { ticketNumber: "T-04", memberId: "m38" },
      { ticketNumber: "T-05", memberId: "m2" },
      { ticketNumber: "T-06", memberId: "m6" },
      { ticketNumber: "T-07", memberId: "m17" },
      { ticketNumber: "T-08", memberId: "m20" },
      { ticketNumber: "T-09", memberId: "m26" },
      { ticketNumber: "T-10", memberId: "m34" },
    ],
    wonCycles: [
      { cycle: 1, memberId: "m5", winningBid: 19200 },
      { cycle: 2, memberId: "m14", winningBid: 20000 },
      { cycle: 3, memberId: "m24", winningBid: 19000 },
      { cycle: 4, memberId: "m38", winningBid: 19400 },
      { cycle: 5, memberId: "m2", winningBid: 18800 },
      { cycle: 6, memberId: "m6", winningBid: 19100 },
      { cycle: 7, memberId: "m17", winningBid: 18900 },
      { cycle: 8, memberId: "m20", winningBid: 19300 },
      { cycle: 9, memberId: "m26", winningBid: 18700 },
      { cycle: 10, memberId: "m34", winningBid: 19500 },
    ],
    createdBy: "Priya Sharma",
    createdAt: "2025-01-10T09:00:00.000Z",
    updatedBy: "Priya Sharma",
    updatedAt: "2025-12-10T09:00:00.000Z",
  },
  {
    id: "g13",
    groupCode: "2025-0013",
    name: "Durga-5",
    monthlyInstallment: 5000,
    memberCount: 8,
    chitValue: 40000,
    startDate: "2025-06-01T00:00:00.000Z",
    auctionDay: 1,
    dueDay: 3,
    organizerMemberId: "m2",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 250,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 50,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "cancelled",
    cancelledReason: "Insufficient member interest; the group was cancelled before its first auction.",
    tickets: [
      { ticketNumber: "T-01", memberId: "m2" },
      { ticketNumber: "T-02", memberId: "m5" },
      { ticketNumber: "T-03", memberId: "m24" },
      { ticketNumber: "T-04", memberId: "m38" },
      { ticketNumber: "T-05", memberId: "m17" },
      { ticketNumber: "T-06", memberId: "m20" },
      { ticketNumber: "T-07", memberId: "m26" },
      { ticketNumber: "T-08", memberId: "m34" },
    ],
    wonCycles: [],
    createdBy: "Suresh Kumar",
    createdAt: "2025-06-01T09:00:00.000Z",
    updatedBy: "Suresh Kumar",
    updatedAt: "2025-06-05T09:00:00.000Z",
  },
  {
    id: "g14",
    groupCode: "2026-0014",
    name: "Kuber-10",
    monthlyInstallment: 10000,
    memberCount: 10,
    chitValue: 100000,
    startDate: "2026-07-01T00:00:00.000Z",
    auctionDay: 25,
    dueDay: 28,
    organizerMemberId: "m4",
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    minDiscountPct: null,
    maxDiscountPct: null,
    bidStep: 500,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    gracePeriodDays: 5,
    lateFee: 100,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    status: "active",
    tickets: [
      { ticketNumber: "T-01", memberId: "m4" },
      { ticketNumber: "T-02", memberId: "m28" },
      { ticketNumber: "T-03", memberId: "m20" },
      { ticketNumber: "T-04", memberId: "m31" },
      { ticketNumber: "T-05", memberId: "m33" },
      { ticketNumber: "T-06", memberId: "m38" },
      { ticketNumber: "T-07", memberId: "m41" },
      { ticketNumber: "T-08", memberId: "m46" },
      { ticketNumber: "T-09", memberId: "m48" },
      { ticketNumber: "T-10", memberId: "m52" },
    ],
    wonCycles: [{ cycle: 1, memberId: "m28", winningBid: 95000 }],
    createdBy: "Anita Desai",
    createdAt: "2026-07-01T09:00:00.000Z",
    updatedBy: "Anita Desai",
    updatedAt: "2026-07-01T10:00:00.000Z",
  },
];